import { useEffect, useState } from "react";
import { FormatMoney } from "helpers/format-money";
import AvailableBalanceCard from "../lite/available-balance-card";
import { useSpendOrganizationAccountsQuery } from "graphql/generated";
import ProgramOverview from "./program-overview";
import DebitCards from "../lite/debit-cards";
import ParentSignups from "./parent-signup";
import GroupsOverview from "./groups-overview";
import { ITEMS_PER_PAGE } from "../../../constants";

function AdminDashboard() {
  const [totalBalance, setTotalBalance] = useState(0);
  const { loading: loadingAccounts, data: accountData } =
    useSpendOrganizationAccountsQuery();

  useEffect(() => {
    if (
      !loadingAccounts &&
      accountData &&
      accountData.spendOrganizationAccounts
    ) {
      let spendAccounts = accountData.spendOrganizationAccounts;
      setTotalBalance(spendAccounts.totalBalance ?? 0);
    }
    // eslint-disable-next-line
  }, [loadingAccounts, accountData]);
  return (
    <>
      <div className="card lg:grid grid-cols-2 gap-6">
        <div>
          <AvailableBalanceCard totalAvailable={FormatMoney(totalBalance)} />
        </div>
        <div className="pt-10">
          <ProgramOverview />
        </div>
      </div>
      <div className="lg:grid grid-cols-2 gap-4">
        <div className="card mr-0">
          <h1 className="text-lg font-bold">Debit Cards</h1>
          <DebitCards itemsPerPage={ITEMS_PER_PAGE} />
        </div>
        <div className="card ml-0">
          <ParentSignups />
        </div>
      </div>
      <div className="card">
        <GroupsOverview />
      </div>
    </>
  );
}

export default AdminDashboard;
